import styled from "styled-components";

export const Content = styled.div`
    margin: 3rem 0;
    position: relative;

    .blog-title {
        p {
            font-size: 2rem;
            position: relative;

            strong {
                color: #fe8418;
            }

            &:before {
                content: "";
                width: 70%;
                height: 2px;
                background: #000;
                position: absolute;
                bottom: 14px;
                right: 1%;
            }
        }

        @media (max-width: 768px) {
            p {
                font-size: 2.4rem;

                &:before {
                    width: 46%;
                    top: 11.5%;
                }
            }
        }

        @media (max-width: 768px) {
            p {
                font-size: 2.2rem;
                text-align: center;

                &:before {
                    content: none;
                }
            }
        }
    }

    .cards-blog {
        @media (max-width: 768px) {
            display: flex;
            justify-content: center;

            .slick-slider {
                max-width: 600px;
            }

            .slick-next {
                right: -3.5rem;
            }

            .slick-prev {
                left: -3.5rem;
            }
        }

        @media (max-width: 414px) {
            .slick-slider {
                max-width: 380px;

                div {
                    margin: 0 auto;
                }
            }

            .slick-next {
                right: 0rem;
            }

            .slick-prev {
                left: 0rem;
            }
        }

        @media (max-width: 375px) {
            .slick-slider {
                max-width: 340px;
            }
        }
    }
`;

export const BlogCardContainer = styled.div<{ background }>`
    background-image: url(${(props) => props.background});

    background-size: cover;
    background-position: center;
    width: 14rem;
    height: 22rem;

    display: flex;
    align-items: flex-end;

    border-radius: 1rem;

    > div {
        background-image: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 40%);
        color: #fff;

        border-radius: 0 0 1rem 1rem;
        height: 12rem;

        display: flex;
        flex-direction: column;
        position: relative;

        strong {
            text-align: left;
            margin: 0.5rem;
            font-size: 1.2rem;
        }
        p {
            margin: 0.5rem;
            font-size: 0.9rem;
        }

        a {
            position: absolute;
            text-align: center;
            background: #fff;
            color: #fe8418;
            padding: 0.2rem 3.45rem;
            margin: 0.5rem 1rem;
            text-decoration: none;
            border-radius: 1.2rem;

            bottom: 0.25rem;

            transition: filter ease-in-out 0.2s;

            &:hover {
                filter: brightness(0.8);
            }
        }
    }

    @media (max-width: 768px) {
        width: 12rem;
        height: 20rem;

        > div {
            a {
                padding: 0.2rem 2.4rem;
            }
        }
    }
`;
